export default __webpack_public_path__ + "static/media/cookie-policy.6969df32.jpg";